import { FolderIcon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { BEHAVIOR_FACTOR_TYPES, useBehaviorFactorsTree } from '@/entities/knowledge';
import { Combobox, Item, ItemHeader, ItemTitle } from '@ibsys/kit';

type BehaviorFactorParentProps = {
  parentId?: number | null;
  parentName?: string;
  onParentChange: (parentId: number | null) => void;
  onSelectParent: (id: number) => void;
  disabled?: boolean;
};

export const BehaviorFactorParent: FC<BehaviorFactorParentProps> = ({
  parentId,
  parentName,
  onParentChange,
  onSelectParent,
  disabled,
}) => {
  const { t } = useTranslation('behaviorFactors');
  const { data } = useBehaviorFactorsTree({ isDeleted: false });

  const factorOptions =
    data?.items
      .filter((item) => item.type === BEHAVIOR_FACTOR_TYPES.BEHAVIOR_FACTOR)
      .map((item) => ({
        value: item.id,
        label: item.name,
      })) ?? [];

  return (
    <div className="flex flex-col gap-3">
      <h3 className="text-base font-semibold text-foreground">{t('parentFactor')}</h3>

      {disabled && parentId && parentName ? (
        <li onClick={() => onSelectParent(parentId)}>
          <Item variant="outline" className="hover:bg-muted cursor-pointer">
            <ItemHeader>
              <div className="flex items-center gap-2">
                <FolderIcon className="size-4 shrink-0 text-muted-foreground" />
                <ItemTitle className="text-sm text-primary hover:underline">{parentName}</ItemTitle>
              </div>
            </ItemHeader>
          </Item>
        </li>
      ) : (
        <Combobox
          options={factorOptions}
          value={parentId ?? undefined}
          onChange={(value) => onParentChange(value as number | null)}
          placeholder={t('selectParent')}
          disabled={disabled}
        />
      )}
    </div>
  );
};
